import styled from 'styled-components';
import { Button } from 'antd';

export const Container = styled.div`
  .fullscreen-enabled {
    font-weight: initial;
    overflow: auto;
    .anticon-down-square {
      display: none;
    }
  }
  .custom-table-cell {
    border-color: #333;
    border-style: solid;
    border-bottom-width: 1px;
    border-right-width: 1px;
    border-top-width: 1px;
    .ql-editor {
      padding: 0px;
    }
  }
  .custom-table-row-cell {
    border-color: #333;
    border-style: solid;
    &:first-child {
      border-top-width: 1px;
    }
    > div {
      border-color: #333;
      border-style: solid;
      border-bottom-width: 1px;
      border-right-width: 1px;
    }
  }
  .table-selected-cols,
  .table-settings,
  .custom-col-label {
    visibility: hidden !important;
  }

  .add-button,
  .border-el,
  .group-tag {
    display: none;
  }
`;

export const PreviewButton = styled(Button)`
  font-weight: 600;
  display: flex;
  align-items: center;
  background-color: transparent !important;
  border: 2px solid transparent !important;
  box-shadow: none !important;
  width: auto !important;
  &:hover,
  &:focus {
    background-color: transparent !important;
    border-color: transparent !important;
    box-shadow: initial;
  }
  .anticon {
    color: #fff !important;
  }
`;

export const PreviewIframe = styled.div`
    display: flex;
    flex-direction: column;
    width: ${props => props.currentView === 3 ? '360px' : props.currentView === 2 ? '768px' : '1280px'};
    height: 100%;
    margin: 0px auto;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
`;

export const PreviewModeDiv = styled.div`
  display: flex;

  button {
    margin: 0 10px;
    z-index: 12;
    pointer-events: auto;
  }
`;
